import React, { useEffect, useState } from "react";

// CSS
import "./../../../assets/css/purchase/datatable.css";

// Utils
import {
  formatCurrency,
  getData,
  getDataWithComp,
  parseCurrency,
} from "../../../utils/SamuiUtils";
import { formatDate } from "../../../utils/DateUtils";
import FileModal from "../Modal/FileModal";
import Pagination from "../Footer/Pagination";

const DataTable = ({
  currentItems,
  onRowSelected,
  currentPage,
  setCurrentPage,
  handlePageChange,
  dataMasterList,
  setDataMasterList,
  itemsPerPage,
  setItemsPerPage,
  fieldMappings,
  getReport,
}) => {
  const [selectedRow, setSelectedRow] = useState(
    localStorage.getItem("selectedRow") || null
  );
  const [selectedRowIndex, setSelectedRowIndex] = useState(0); // เพิ่ม state สำหรับ index ของแถวที่เลือก
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedRecFiles, setSelectedRecFiles] = useState([]);
  const [itemsPerPageDropdown, setItemsPerPageDropdown] = useState(
    localStorage.getItem("itemsPerPageDropdown") || itemsPerPage
  );
  const [sortColumn, setSortColumn] = useState(
    localStorage.getItem("sortColumn") || null
  );
  const [sortOrder, setSortOrder] = useState(
    localStorage.getItem("sortOrder") || "asc"
  );
  const [optimisticPrinted, setOptimisticPrinted] = useState(new Set());

  useEffect(() => {
    if (sortColumn !== null) {
      const sortedData = [...dataMasterList].sort((a, b) => {
        const aValue = a[sortColumn];
        const bValue = b[sortColumn];
        if (sortOrder === "asc") {
          return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        } else {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        }
      });
      setDataMasterList(sortedData);

      localStorage.setItem("sortColumn", sortColumn);
      localStorage.setItem("sortOrder", sortOrder);
    }
  }, [sortColumn, sortOrder, dataMasterList, setDataMasterList]);

  useEffect(() => {
    localStorage.setItem("itemsPerPageDropdown", itemsPerPageDropdown);
  }, [itemsPerPageDropdown]);

  // เพิ่ม keyboard navigation สำหรับตาราง
  useEffect(() => {
    const handleKeyDown = (event) => {
      // ป้องกันการทำงานถ้ามี modal เปิดอยู่หรือ focus อยู่ใน input field
      if (showViewAttachModal ||
        document.activeElement.tagName === 'INPUT' ||
        document.activeElement.tagName === 'TEXTAREA' ||
        document.activeElement.tagName === 'SELECT') {
        return;
      }

      if (currentItems.length === 0) return;

      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault();
          setSelectedRowIndex(prevIndex => {
            const newIndex = prevIndex > 0 ? prevIndex - 1 : currentItems.length - 1;
            const newRowId = currentItems[newIndex][fieldMappings.no] || newIndex + 1;
            setSelectedRow(newRowId);
            localStorage.setItem("selectedRow", newRowId);
            return newIndex;
          });
          break;

        case 'ArrowDown':
          event.preventDefault();
          setSelectedRowIndex(prevIndex => {
            const newIndex = prevIndex < currentItems.length - 1 ? prevIndex + 1 : 0;
            const newRowId = currentItems[newIndex][fieldMappings.no] || newIndex + 1;
            setSelectedRow(newRowId);
            localStorage.setItem("selectedRow", newRowId);
            return newIndex;
          });
          break;

        case 'Enter':
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            onRowSelected(currentItems[selectedRowIndex][fieldMappings.no]);
          }
          break;

        case 'p':
        case 'P':
          event.preventDefault();
          if (currentItems[selectedRowIndex] && getReport) {
            getReport(currentItems[selectedRowIndex][fieldMappings.no]);
          }
          break;

        case 'ArrowLeft':
          event.preventDefault();
          if (currentPage > 1) {
            handlePageChange(currentPage - 1);
          }
          break;

        case 'ArrowRight':
          event.preventDefault();
          const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
          if (currentPage < totalPages) {
            handlePageChange(currentPage + 1);
          }
          break;

      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentItems, selectedRowIndex, onRowSelected, getReport, showViewAttachModal, fieldMappings, currentPage, handlePageChange, dataMasterList.length, itemsPerPage]);

  // อัพเดต selectedRowIndex เมื่อ selectedRow เปลี่ยน
  useEffect(() => {
    if (selectedRow && currentItems.length > 0) {
      const index = currentItems.findIndex(item =>
        (item[fieldMappings.no] || currentItems.indexOf(item) + 1) == selectedRow
      );
      if (index !== -1) {
        setSelectedRowIndex(index);
      }
    }
  }, [selectedRow, currentItems, fieldMappings]);

  const renderSortArrow = (column) => {
    if (sortColumn === column) {
      return (
        <i
          className={`fa fa-arrow-${sortOrder === "asc" ? "up" : "down"}`}
          style={{ marginLeft: "5px" }}
        ></i>
      );
    }
    return (
      <>
        <i className="fa fa-arrow-up" style={{ marginLeft: "5px" }}></i>
        <i className="fa fa-arrow-down" style={{ marginLeft: "5px" }}></i>
      </>
    );
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPageDropdown + 1;
  const endIndex = Math.min(
    currentPage * itemsPerPageDropdown,
    dataMasterList.length
  );

  const handleShowModal = async (files, docNo) => {
    let processedFiles = [];

    // ประมวลผลไฟล์หลัก (เหมือนเดิม)
    if (Array.isArray(files)) {
      for (const fileName of files) {
        if (typeof fileName === "string") {
          try {
            const fileData = await getDataWithComp(
              "Upload_File_List",
              `AND File_Name = '${fileName}'`
            );

            if (fileData && fileData.length > 0) {
              processedFiles.push(fileData[0]);
            } else {
              processedFiles.push({
                File_Name: fileName,
                File_Url: `${window.location.origin}/uploads/${fileName}`,
                name: fileName,
              });
            }
          } catch (error) {
            console.error("Error fetching file data:", error);
            processedFiles.push({
              File_Name: fileName,
              File_Url: `${window.location.origin}/uploads/${fileName}`,
              name: fileName,
            });
          }
        } else {
          processedFiles.push(fileName);
        }
      }
    } else if (typeof files === "string") {
      const fileNames = files.split(",").map((name) => name.trim());

      for (const fileName of fileNames) {
        try {
          const fileData = await getDataWithComp(
            "Upload_File_List",
            `AND File_Name = '${fileName}'`
          );

          if (fileData && fileData.length > 0) {
            processedFiles.push(fileData[0]);
          } else {
            processedFiles.push({
              File_Name: fileName,
              File_Url: `${window.location.origin}/uploads/${fileName}`,
              name: fileName,
            });
          }
        } catch (error) {
          console.error("Error fetching file data:", error);
          processedFiles.push({
            File_Name: fileName,
            File_Url: `${window.location.origin}/uploads/${fileName}`,
            name: fileName,
          });
        }
      }
    }

    console.log("processedFiles:", processedFiles);

    // สำหรับใบสำคัญจ่ายเท่านั้น หน้าอื่นไม่กระทบ
    if (window.location.pathname === "/payment-voucher" && docNo) {
      try {
        const getPayH = await getDataWithComp(
          "PAY_H",
          `AND Pay_No = '${docNo}'`
        );

        if (getPayH && getPayH.length > 0) {
          const getPayD = await getData(
            "PAY_D",
            `Pay_Id = ${getPayH[0].Pay_Id}`
          );

          if (getPayD && getPayD.length > 0) {
            // ใช้ Set เพื่อเก็บ Doc_ID ที่ไม่ซ้ำกัน
            const uniqueRecIds = new Set();
            getPayD.forEach((pay) => {
              if (pay.Rec_Id) {
                uniqueRecIds.add(pay.Rec_Id);
              }
            });

            console.log("Unique Rec IDs:", Array.from(uniqueRecIds));

            // ดึงไฟล์จาก Rec_Id ที่ไม่ซ้ำกัน
            let recFiles = [];
            for (const recId of uniqueRecIds) {
              try {
                const getRecFiles = await getDataWithComp(
                  "Upload_File_List",
                  `AND DocCode_ID = 3 AND Doc_ID = ${recId}`
                );

                if (getRecFiles && getRecFiles.length > 0) {
                  // ตรวจสอบว่าไฟล์ยังไม่มีใน array (ป้องกันการซ้ำอีกชั้น)
                  getRecFiles.forEach((file) => {
                    const isDuplicate = recFiles.some(
                      (existingFile) =>
                        existingFile.F_Id === file.F_Id ||
                        existingFile.File_Name === file.File_Name
                    );

                    if (!isDuplicate) {
                      recFiles.push(file);
                    }
                  });
                }
              } catch (error) {
                console.error(
                  `Error fetching files for Rec_Id ${recId}:`,
                  error
                );
              }
            }

            console.log("Final recFiles (no duplicates):", recFiles);
            setSelectedRecFiles(recFiles);
          }
        }
      } catch (error) {
        console.error("Error processing payment voucher files:", error);
        setSelectedRecFiles([]);
      }
    }

    setSelectedFiles(processedFiles);
    setShowViewAttachModal(true);
  };

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage = parseCurrency(event.target.value);
    setItemsPerPageDropdown(newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    handlePageChange(1);
  };

  // เอามาใช้สำหรับหน้าใบจ่าย ให้ดักว่าเป็นผู้ขาย หรือ ลูกค้า
  const getApOrArCode = (data) => {
    return data[fieldMappings.apCode] || data[fieldMappings.apName]
      ? { code: data[fieldMappings.apCode], name: data[fieldMappings.apName] }
      : { code: data["AR_Code"], name: data["AR_Name"] };
  };

  return (
    <div className="card">
      <div
        className="table-responsive"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <table
          id="basic-datatables"
          className="table table-striped table-hover"
        >
          <thead className="thead-dark">
            <tr>
              <th
                className="text-center"
                style={{ width: "2%" }}
                onClick={() => handleSort(fieldMappings.no)}
              >
                เลขที่เอกสาร
                {/* {sortColumn === fieldMappings.no && ( */}
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.no)}
                </span>
                {/* )} */}
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "7%" }}
                onClick={() => handleSort(fieldMappings.docBlNo)}
              >
                เลขที่ใบวางบิล
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.docBlNo)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" &&
                    localStorage.getItem("company") === "2"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "9%" }}
                onClick={() => handleSort(fieldMappings.docInvNo)}
              >
                เลขใบกำกับภาษี
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.docInvNo)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ? false : true
                }
                className="text-center"
                style={{ width: "2%" }}
                onClick={() => handleSort(fieldMappings.refDoc)}
              >
                เลขที่อ้างอิง
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.refDoc)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/picking-list" ||
                    window.location.pathname === "/billofsale"
                    ? true
                    : false
                }
                className="text-center"
                style={{ width: "7%" }}
                onClick={() => handleSort(fieldMappings.typeName)}
              >
                ประเภท
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.typeName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/quotation" ? false : true
                }
                className="text-center"
                style={{ width: "7%" }}
                onClick={() => handleSort(fieldMappings.docSoNo)}
              >
                เลขที่ใบขาย
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.docSoNo)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/payment-voucher" ? false : true
                }
                className="text-center"
                style={{ width: "10%" }}
                onClick={() => handleSort(fieldMappings.payTypeName)}
              >
                ประเภทการจ่าย
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.payTypeName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "4%" }}
                onClick={() => handleSort(fieldMappings.docIsPickingList)}
              >
                ประเภท
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.docIsPickingList)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-request"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "6%" }}
                onClick={() => handleSort(fieldMappings.statusName)}
              >
                สถานะเอกสาร
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-request" ||
                    window.location.pathname === "/payment-voucher" ||
                    window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/quotation"
                    ? true
                    : false
                }
                className="text-center"
                style={{ width: "12%" }}
                onClick={() => handleSort(fieldMappings.statusName)}
              >
                สถานะเอกสาร
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                className="text-center"
                style={{ width: "8%" }}
                onClick={() => handleSort(fieldMappings.dlLineName)}
              >
                สายส่ง
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.dlLineName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "8%" }}
                onClick={() => handleSort(fieldMappings.statusPaidName)}
              >
                สถานะจ่าย
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusPaidName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ? false : true
                }
                className="text-center"
                style={{ width: "12%" }}
                onClick={() => handleSort(fieldMappings.statusPaidName)}
              >
                สถานะจ่าย
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusPaidName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/quotation"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "12%" }}
                onClick={() => handleSort(fieldMappings.statusPaidTypeName)}
              >
                ประเภทการจ่าย
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusPaidTypeName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-order" ? false : true
                }
                className="text-center"
                style={{ width: "10%" }}
                onClick={() => handleSort(fieldMappings.statusReceiveName)}
              >
                สถานะรับสินค้า
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusReceiveName)}
                </span>
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-order" ? false : true
                }
                className="text-center"
                style={{ width: "10%" }}
                onClick={() => handleSort(fieldMappings.statusPaidName)}
              >
                สถานะชำระล่วงหน้า
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.statusPaidName)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "6%" }}
                onClick={() => handleSort(fieldMappings.date)}
              >
                วันที่เอกสาร
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.date)}
                </span>
              </th>
              <th
                className="text-center"
                hidden={
                  window.location.pathname === "/purchase-request" ||
                    window.location.pathname === "/picking-list"
                    ? true
                    : false
                }
                style={{ width: "6%" }}
                onClick={() => handleSort(fieldMappings.dueDate)}
              >
                {window.location.pathname === "/purchase-order"
                  ? "วันที่จัดส่ง"
                  : window.location.pathname === "/product-receipt"
                    ? "วันที่รับ"
                    : window.location.pathname === "/payment-voucher"
                      ? "วันที่ชำระ"
                      : "Due Date"}
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.dueDate)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "7%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/quotation" ||
                  window.location.pathname === "/deposit-document" ||
                  window.location.pathname === "/billofsale"
                  ? "รหัสลูกค้า"
                  : "รหัสเจ้าหนี้"}
              </th>
              <th
                className="text-center"
                style={{ width: "20%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/quotation" ||
                  window.location.pathname === "/deposit-document" ||
                  window.location.pathname === "/billofsale"
                  ? "ชื่อลูกค้า"
                  : "ชื่อเจ้าหนี้"}
              </th>
              <th
                hidden={
                  window.location.pathname === "/deposit-document" ||
                    window.location.pathname === "/billofsale"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "8%" }}
                onClick={() => handleSort(fieldMappings.dlLineName)}
              >
                สายส่ง
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.dlLineName)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                onClick={() => handleSort(fieldMappings.driver1)}
              >
                คนขับรถที่ 1
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.driver1)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                onClick={() => handleSort(fieldMappings.driver2)}
              >
                คนขับรถที่ 2
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.driver2)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                onClick={() => handleSort(fieldMappings.driver3)}
              >
                คนขับรถที่ 3
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.driver3)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "8%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                onClick={() => handleSort(fieldMappings.carNo)}
              >
                ทะเบียนรถ
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.carNo)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "7%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
                onClick={() => handleSort(fieldMappings.netTotal)}
              >
                {window.location.pathname === "/payment-voucher"
                  ? "รวมจ่ายสุทธิ"
                  : "ยอดรวม"}
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.netTotal)}
                </span>
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/purchase-request" ||
                    window.location.pathname === "/purchase-order" ||
                    window.location.pathname === "/billofsale"
                    ? true
                    : false
                }
                onClick={() => handleSort(fieldMappings.createdBy)}
              >
                สร้างรายการ โดย
                <span style={{ display: "block", marginTop: "5px" }}>
                  {renderSortArrow(fieldMappings.createdBy)}
                </span>
              </th>

              {window.location.pathname === "/purchase-request" && (
                <>
                  <th
                    className="text-center"
                    style={{ width: "10%" }}
                    onClick={() => handleSort(fieldMappings.empName)}
                  >
                    ผู้สั่งซื้อ
                    <span style={{ display: "block", marginTop: "5px" }}>
                      {renderSortArrow(fieldMappings.empName)}
                    </span>
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "6%" }}
                    onClick={() => handleSort(fieldMappings.deptName)}
                  >
                    แผนกที่สั่งซื้อ
                    <span style={{ display: "block", marginTop: "5px" }}>
                      {renderSortArrow(fieldMappings.deptName)}
                    </span>
                  </th>
                </>
              )}

              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  window.location.pathname === "/purchase-request" ||
                    window.location.pathname === "/product-receipt" ||
                    window.location.pathname === "/payment-voucher" ||
                    window.location.pathname === "/quotation"
                    ? false
                    : true
                }
              >
                ไฟล์
              </th>
              <th className="text-center" style={{ width: "1%" }}>
                แก้ไข
              </th>
              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                พิมพ์
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((data, index) => {
                const { code, name } = getApOrArCode(data);
                const rowId = data[fieldMappings.no] || index + 1;

                return (
                  <tr
                    key={rowId}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedRow === rowId
                          ? "rgb(105, 188, 216)"
                          : "transparent",
                      transition: "background-color 0.3s ease",
                    }}
                    onClick={() => {
                      setSelectedRow(rowId);
                      setSelectedRowIndex(index);
                      localStorage.setItem("selectedRow", rowId);
                    }}
                  >
                    <td className="text-center">
                      {data[fieldMappings.no] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.docBlNo] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/billofsale" &&
                          localStorage.getItem("company") === "2"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.docInvNo] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.refDoc] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/payment-voucher" ||
                          window.location.pathname === "/picking-list" ||
                          window.location.pathname === "/billofsale"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.typeName] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/quotation" ? false : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.docSoNo] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {/* {data[fieldMappings.docIsPickingList]} */}

                      <button
                        className="btn"
                        style={{
                          backgroundColor:
                            data[fieldMappings.docIsPickingList] === 0 ||
                              data[fieldMappings.docIsPickingList] === null
                              ? "#EAA300"
                              : "#13A10E",
                          color: "white",
                          width: "100%",
                        }}
                      >
                        {data[fieldMappings.docIsPickingList] === 0 ||
                          data[fieldMappings.docIsPickingList] === null
                          ? "S"
                          : "V"}
                      </button>
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/quotation"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.statusName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data[fieldMappings.statusColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/payment-voucher"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.payTypeName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data[fieldMappings.statusColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.payTypeName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.dlLineName] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/purchase-order"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusReceiveColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusReceiveName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/purchase-order"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusPaidName] &&
                        data[fieldMappings.statusPaidName] !== "-" ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusPaidName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColour],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] === "ยกเลิก" ? (
                        data[fieldMappings.statusName] ? (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: data[fieldMappings.statusColour],
                              color: "white",
                              width: "100%",
                            }}
                          >
                            {data[fieldMappings.statusName]}
                          </button>
                        ) : (
                          <center>
                            <p>-</p>
                          </center>
                        )
                      ) : data[fieldMappings.statusPaidName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColour],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/quotation"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] === "ยกเลิก" ? (
                        data[fieldMappings.statusName] ? (
                          <button
                            className="btn"
                            style={{
                              backgroundColor:
                                '#808080',
                              color: "white",
                              width: "100%",
                            }}
                          >
                            {data[fieldMappings.statusName]}
                          </button>
                        ) : (
                          <center>
                            <p>-</p>
                          </center>
                        )
                      ) : (
                        data[fieldMappings.statusPaidTypeName] !== null ? (
                          <button
                            className="btn"
                            style={{
                              backgroundColor:
                                data[fieldMappings.statusPaidTypeColour],
                              color: "white",
                              width: "100%",
                            }}
                          >
                            {data[fieldMappings.statusPaidTypeName]}
                          </button>
                        ) : (
                          data[fieldMappings.statusName] === "ยกเลิก" ? (
                            data[fieldMappings.statusName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    '#808080',
                                  color: "white",
                                  width: "100%",
                                }}
                              >
                                {data[fieldMappings.statusName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )
                          ) : data[fieldMappings.statusPaidName] ? (
                            <button
                              className="btn"
                              style={{
                                backgroundColor:
                                  data[fieldMappings.statusPaidColour],
                                color: "white",
                                width: "100%",
                              }}
                            >
                              {data[fieldMappings.statusPaidName]}
                            </button>
                          ) : (
                            <center>
                              <p>-</p>
                            </center>
                          )
                        ))}
                    </td>
                    <td className="text-center">
                      {data[fieldMappings.date]
                        ? formatDate(data[fieldMappings.date])
                        : "-"}
                    </td>
                    <td
                      className="text-center"
                      hidden={
                        window.location.pathname === "/purchase-request" ||
                          window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.dueDate]
                        ? formatDate(data[fieldMappings.dueDate])
                        : "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      {code || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-left"
                    >
                      {name || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/deposit-document" ||
                          window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.dlLineName] || "-"}
                    </td>
                    <td
                      className="text-end"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                    </td>

                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver1] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver2] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver3] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.carNo] || "-"}
                    </td>

                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/purchase-request" ||
                          window.location.pathname === "/purchase-order" ||
                          window.location.pathname === "/billofsale"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.createdBy] || "-"}
                    </td>

                    {window.location.pathname === "/purchase-request" && (
                      <>
                        <td className="text-left">
                          {data[fieldMappings.empName] || "-"}
                        </td>
                        <td className="text-left">
                          {data[fieldMappings.deptName] || "-"}
                        </td>
                      </>
                    )}

                    <td
                      hidden={
                        window.location.pathname === "/purchase-request" ||
                          window.location.pathname === "/product-receipt" ||
                          window.location.pathname === "/payment-voucher" ||
                          window.location.pathname === "/quotation"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {/* เพิ่ม debug สำหรับ Quotation */}
                      {window.location.pathname === "/quotation" &&
                        (() => {
                          console.log("=== QUOTATION DEBUG ===");
                          console.log("Doc No:", data[fieldMappings.no]);
                          console.log(
                            "fieldMappings.File_Name:",
                            fieldMappings.File_Name
                          );
                          console.log(
                            "data[fieldMappings.File_Name]:",
                            data[fieldMappings.File_Name]
                          );
                          console.log(
                            "Type:",
                            typeof data[fieldMappings.File_Name]
                          );
                          console.log(
                            "Is Array:",
                            Array.isArray(data[fieldMappings.File_Name])
                          );
                          console.log(
                            "Length:",
                            data[fieldMappings.File_Name]?.length
                          );
                          console.log("Full data object:", data);
                          console.log("======================");
                          return null;
                        })()}

                      {window.location.pathname === "/payment-voucher" &&
                        (data[fieldMappings.File_Name]?.length > 0 ||
                          data[fieldMappings.File_Name_Rec]?.length > 0 ? (
                          <button
                            className="btn btn-link btn-sm px-3"
                            onClick={() =>
                              handleShowModal(
                                data[fieldMappings.File_Name],
                                data[fieldMappings.no]
                              )
                            }
                          >
                            <i
                              className="fas fa-paperclip"
                              style={{
                                fontSize: "16px",
                                color: "rgb(239, 108, 0)",
                              }}
                            ></i>
                          </button>
                        ) : (
                          "-"
                        ))}

                      {window.location.pathname !== "/payment-voucher" &&
                        (data[fieldMappings.File_Name] &&
                          Array.isArray(data[fieldMappings.File_Name]) &&
                          data[fieldMappings.File_Name].length > 0 ? (
                          <button
                            className="btn btn-link btn-sm px-3"
                            onClick={() =>
                              handleShowModal(
                                data[fieldMappings.File_Name],
                                data[fieldMappings.no]
                              )
                            }
                          >
                            <i
                              className="fas fa-paperclip"
                              style={{
                                fontSize: "16px",
                                color: "rgb(239, 108, 0)",
                              }}
                            ></i>
                          </button>
                        ) : (
                          "-"
                        ))}

                      {showViewAttachModal && (
                        <FileModal
                          mode={"S"}
                          showViewAttachModal={showViewAttachModal}
                          setShowViewAttachModal={setShowViewAttachModal}
                          selectedFiles={selectedFiles}
                          selectedRecFiles={selectedRecFiles}
                        />
                      )}
                    </td>

                    <td className="text-center">
                      <button
                        className="btn btn-link btn-sm px-3"
                        onClick={() => onRowSelected(data[fieldMappings.no])}
                      >
                        <i
                          className="fa fa-edit"
                          style={{
                            color: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                        ></i>
                      </button>
                    </td>

                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      <button
                        className="btn btn-link btn-sm px-3"
                        onClick={() => {
                          const rowId = data[fieldMappings.no] || index + 1;
                          setOptimisticPrinted((prev) => {
                            const s = new Set(prev);
                            s.add(rowId);
                            return s;
                          });
                          getReport(data[fieldMappings.no]);
                        }}
                      >
                        {(() => {
                          const printedKey = fieldMappings.printedStatus;
                          const printedValue = printedKey ? (data[printedKey] || "") : "";
                          const alreadyPrinted = String(printedValue).toUpperCase() === "Y";
                          const rowId = data[fieldMappings.no] || index + 1;
                          const isPrinted = alreadyPrinted || optimisticPrinted.has(rowId);
                          return (
                            <i
                              className="fa fa-print"
                              style={{ fontSize: "16px", color: isPrinted ? '#13A10E' : 'rgb(13,110,253)' }}
                            ></i>
                          );
                        })()}
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={14}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
          {/* ใบสั่งซื้อ */}
          {window.location.pathname === "/purchase-order" && (
            <tr
              style={{
                backgroundColor: "#f8f9fa",
                fontWeight: "bold",
                borderTop: "2px solid #dee2e6",
              }}
            >
              <td
                className="text-end"
                colSpan={9}
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
                ยอดรวม
              </td>
              <td
                className="text-end"
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
                {formatCurrency(
                  currentItems.reduce(
                    (sum, item) =>
                      sum + (parseCurrency(item[fieldMappings.netTotal]) || 0),
                    0
                  )
                )}
              </td>
              <td
                className="text-end"
                colSpan={4}
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
              </td>
            </tr>
          )}
          {/* ใบขาย */}
          {window.location.pathname === "/billofsale" && (
            <tr
              style={{
                backgroundColor: "#f8f9fa",
                fontWeight: "bold",
                borderTop: "2px solid #dee2e6",
              }}
            >
              <td
                className="text-end"
                colSpan={11}
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
                ยอดรวม
              </td>
              <td
                className="text-end"
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
                {formatCurrency(
                  currentItems.reduce(
                    (sum, item) =>
                      sum + (parseCurrency(item[fieldMappings.netTotal]) || 0),
                    0
                  )
                )}
              </td>
              <td
                className="text-end"
                colSpan={2}
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
              </td>
            </tr>
          )}
        </table>
      </div>

      {/* อยากได้ยอดท้ายตาราง */}

      {/* Footer */}
      <div className="d-flex justify-content-between align-items-center p-3">
        {/* ตัวเลือกจำนวนแถว */}
        <div>
          <select
            value={itemsPerPageDropdown}
            onChange={handleItemsPerPageChange}
            className="form-select"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        {/* การแสดงจำนวนข้อมูล */}
        <div>
          <span>
            แสดง {startIndex}-{endIndex} ของ{" "}
            {dataMasterList.length.toLocaleString()} รายการ
          </span>
        </div>

        {/* Keyboard shortcuts info */}
        <div className="card-footer bg-light p-2">
          <small className="text-muted">
            <i className="fas fa-keyboard me-1"></i>
            <strong>คีย์ลัด:</strong>
            ↑↓ เลือกแถว | ←→ เปลี่ยนหน้า | Enter เข้าดู | P พิมพ์
          </small>
        </div>

        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPageDropdown}
          dataMasterList={dataMasterList}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default DataTable;
